import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { okvedApi } from 'entities/okved/api-slice';

export const useOkvedPartitionList = () => {
  const { data, isLoading, error } = okvedApi.useGetOkvedPartitionListQuery();
  return {
    collection: data || [],
    error: extractNestJsErrorMessage(error),
    isLoading: isLoading
  };
};

export const useOkvedGroupList = (id: number) => {
  const { data, isLoading, error } = okvedApi.useGetOkvedGroupListQuery(id, { skip: id === 0, refetchOnMountOrArgChange: 60 });
  return {
    collection: data || [],
    error: extractNestJsErrorMessage(error),
    isLoading: isLoading
  };
};

export const useDeleteOkvedPartition = () => {
  const [deleteOkvedPartition] = okvedApi.useDeleteOkvedPartitionMutation();
  return async (id: number) => {
    return deleteOkvedPartition(id).unwrap();
  };
};

export const useDeleteOkvedGroup = () => {
  const [deleteOkvedGroup] = okvedApi.useDeleteOkvedGroupMutation();
  
  return async (id: number, partitionId: number) => {
    return deleteOkvedGroup({ id, partitionId }).unwrap();
  };
};